import React, { memo, useMemo } from 'react';
import { FormSelect, FormSelectProps, FormSelectItem, OptionItemProps } from '@core/components/form';
import { CommonService } from '@business/services';
import { BOXICONS, FA_REGULAR, FA_SOLID } from '@business/constants/icons';

const CustomOption = memo((props: OptionItemProps<FormSelectItem<any> | null>) => {
  return (
    <div>
      <i className={`${props.item.value} mr-2 font-size-16`}></i>
      {props.item.label}
    </div>
  );
});

export type FormIconSelectProps<T extends any> = Omit<FormSelectProps<T>, 'items'>;

export function FormIconSelect(props: FormIconSelectProps<string>) {
  const iconItems = useMemo(
    () =>
      CommonService.selectGroupedItems(
        [
          { label: 'FontAwesome Solid', items: FA_SOLID },
          { label: 'FontAwesome Regular', items: FA_REGULAR },
          { label: 'Boxicons', items: BOXICONS },
        ],
        'label',
        s => s.items,
        i => i,
        i => i,
      ),
    [],
  );
  return <FormSelect {...props} type="single" items={iconItems} itemRenderer={CustomOption} />;
}
